import angular from 'angular';
import { PageComponent } from './page.component';

export const PageModule = angular
  .module('app.forgot-password.page', [])
  .component('updForgotPasswordPage', PageComponent);
